import z from "zod";
import { DocType } from "@/domain/shared";
import { endOfDay, startOfDay } from "date-fns";
import { calculateAge } from "./dates";

export const emailSchema = z.string().regex(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'El formato del email es inválido').optional().or(z.literal(''));

export const isValidDocNumber = (docType: DocType | string, docNumber?: string) => {
  if (!docNumber) return false;

  const cleanDocNumber = docNumber.replaceAll(/[^0-9]/g, '');

  switch (docType) {
    case DocType.DNI:
      return cleanDocNumber.length >= 7 && cleanDocNumber.length <= 9;
    case DocType.CUIT:
    case DocType.CUIL:
    case DocType.CDI:
      return cleanDocNumber.length === 11;
    case DocType.LE:
    case DocType.LC:
      return cleanDocNumber.length === 7;
    case DocType.PREC:
      return cleanDocNumber.length >= 8 && cleanDocNumber.length <= 11;
    case DocType.PAS:
      return cleanDocNumber.length === 9 || cleanDocNumber.length === 10;
    default:
      return true;
  }
};

export const validOptionalDate = z.date().optional().nullable()
  .refine(date => !date || startOfDay(date) < endOfDay(new Date()), { message: 'La fecha debe ser anterior a la fecha actual' })

export const optionalDate = z.date().optional().nullable()

export const dateOfBirthSchema = z.date({ message: 'La fecha es requerida' })
  .refine(date => startOfDay(date) < endOfDay(new Date()), { message: 'La fecha debe ser anterior a la fecha actual' })
  .nonoptional({ message: 'La fecha de nacimiento es requerida' })

export const dateOfBirthAdultSchema = dateOfBirthSchema
  .refine(date => calculateAge(date) >= 18, { message: 'El Titular debe tener al menos 18 años' })